import { configureSlices } from "utils/store/configureSlices";

import smc3IntegrationsSlice from "./smc3IntegrationsSlice";

export const { useSlices: usePartnersSlice, useSliceSelector: usePartnersSliceSelector } = configureSlices({
  smc3IntegrationsSlice,
});
